export const BANK_SCRAPING_STATUS = {
  COMPLETE: 'COMPLETE',
  LOGIN_FAIL: 'LOGIN_FAIL',
  ERROR: 'ERROR',
};

export const BANK_SCRAPING_IFRAME_STATUS = {
  IFRAME_LOAD_FAIL: 'IFRAME_LOAD_FAIL',
  IFRAME_RELOAD: 'IFRAME_RELOAD',
  IFRAME_LOADED: 'IFRAME_LOADED',
  IFRAME_RENDERED: 'IFRAME_RENDERED',
  IFRAME_RENDER_FAIL: 'IFRAME_RENDER_FAIL',
  IFRAME_NO_RESPONSE: 'IFRAME_NO_RESPONSE',
  IFRAME_SILENT: 'IFRAME_SILENT',
};
